<template>
  <div class="master-code-logs container">
    <nav class="breadcrumb mt-5" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/admin">Admin Settings</router-link></li>
        <li class="is-active"><router-link to="/dashboard/master-code-logs" aria-current="true">Master Code Logs</router-link></li>
      </ul>
    </nav>

    <h1 class="title">Git Commit Logs</h1>

    <table class="table is-striped is-fullwidth is-size-7">
      <thead>
        <tr>
          <th>Date</th>
          <th>Author</th>
          <th>Commit URL</th>
          <th>Files Changed</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="commit in commits" :key="commit.commit_id || commit.id">
          <td>{{ formatDate(commit.timestamp) }}</td>
          <td>{{ commit.author_name || "Unknown" }}</td>
          <td>
            <a v-if="commit.commit_id" :href="commit.commit_url" target="_blank">
              {{ commit.commit_id?.substring(0, 7) || "N/A" }}
            </a>
            <span v-else>N/A</span>
          </td>
          <td>
            <ul>
              <li v-if="commit.added_files.length"><strong>Added:</strong> <span class="added">{{ commit.added_files.join(', ') }}</span></li>
              <li v-if="commit.removed_files.length"><strong>Removed:</strong> <span class="removed">{{ commit.removed_files.join(', ') }}</span></li>
              <li v-if="commit.modified_files.length"><strong>Modified:</strong> <span class="modified">{{ commit.modified_files.join(', ') }}</span></li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="loading" class="loading">Loading...</div>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'GitCommitLogs',
  data() {
    return {
      commits: [],
      loading: false,
      error: null
    };
  },
  methods: {
    async fetchCommits() {
      this.loading = true;
      try {
        const response = await axios.get('/api/v1/git-logs/');
        this.commits = response.data.results || []; // Use 'results' for pagination
      } catch (error) {
        console.error('Error fetching commit logs:', error);
        this.error = 'Failed to fetch commit logs. Please try again later.';
      } finally {
        this.loading = false;
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return "N/A";
      const date = new Date(timestamp);
      return date.toLocaleString();
    }
  },
  async created() {
    await this.fetchCommits();
  }
};
</script>

<style scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
}
.table {
  width: 100%;
  margin-top: 20px;
}
.loading {
  text-align: center;
  padding: 10px;
  font-weight: bold;
  color: #3273dc;
}
.error-message {
  text-align: center;
  padding: 10px;
  font-weight: bold;
  color: red;
}
a {
  text-decoration: none;
  color: #3273dc;
}
a:hover {
  text-decoration: underline;
}
.added {
  color: green;
}
.removed {
  color: red;
}
.modified {
  color: orange;
}
</style>
